import { render, staticRenderFns } from "./leftcontain.vue?vue&type=template&id=1bf23123&scoped=true"
import script from "./leftcontain.vue?vue&type=script&lang=js"
export * from "./leftcontain.vue?vue&type=script&lang=js"
import style0 from "./leftcontain.vue?vue&type=style&index=0&id=1bf23123&prod&lang=less&scoped=true"
import style1 from "./leftcontain.vue?vue&type=style&index=1&id=1bf23123&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf23123",
  null
  
)

export default component.exports